<template>
  <DBox id="cmp-settings-user-hide-modules" :addButton="false" :addLink="false" @menuClick="saveChange"
    :rightMenu="[{ text: $t('save_btn'), value: 'save' }]">
    <SelectTree :tree="this.permTree" @changed="onPermTreeChange" />
    <!-- <div class="save-button-container">
      <button class="dt-button s2 v1" @click="saveChange">Save</button>
    </div> -->
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { SelectTree, createNode } from "../../../../plugins/select-tree";

import { defaultTextFieldConfig } from "../../../../plugins/text-field";
import { map, prop, flatten, toPairs } from "ramda";

export default {
  components: {
    DBox,
    SelectTree
  },
  data() {
    return {
      selectedModules: new Set(),
      tree: {}
    };
  },
  props: {
    userDetails: {
      required: true
    },
    appNavItems: {
      required: true,
      default: []
    }

  },
  computed: {
    allPerm: function () {
      return this.userDetails.allPerm;
    },
    permTree: function () {
      let tree = makeSelectTreeNodes(this.userDetails, this.appNavItems);
      // tree.forEach(m => {
      //   const sortingArr = this.appNavItems && this.appNavItems.length > 0 && this.appNavItems.find(a => a.title == m.text) && this.appNavItems.find(a => a.title == m.text)?.children.map(c => c.title) || [];
      //   // if (m.text == "Booking") {
      //   //   sortingArr.push('Tours');
      //   // }
      //   // if (m.text == "Distribution") {
      //   //   sortingArr.push('Supplier Orders');
      //   // }
      //   m.children.sort((a, b) => sortingArr.indexOf(a.text) - sortingArr.indexOf(b.text));
      //   console.log('m.children',m.children)
      // });


      return tree;
    }
  },
  methods: {
    onTextFieldValueChange: function (name, value) {
      console.log(name, value);
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    onModuleSelected: function (event, moduleName) { },
    onPermTreeChange: function (tree) {
      console.log('treess', tree)
      this.tree = makePermissions(tree);
    },
    saveChange: function () {
      this.$emit("changed", { items: this.tree });
    }
    //MARK: Methods
  }
};

("hdhdt Dyab us byus syub Mak jpf bdoo ld");

const makePermissions = tree => {
  let modules = [],
    sub_menu = [],
    tabs = [];
  const getValue = map(prop("value"));
  modules = getValue(tree.filter(e => e.selected));
  sub_menu = getValue(
    flatten(tree.map(e => e.children)).filter(e => e.selected)
  );
  tabs = getValue(
    flatten(tree.map(e => e.children.map(e => e.children))).filter(
      e => e.selected
    )
  );

  console.log({
    modules,
    sub_menu,
    tabs
  });

  return {
    permission: {
      modules,
      sub_menu,
      tabs
    }
  };
};

const makeSelectTreeNodes = (userDetails, appNavItems = []) => {
  const { allPerm, userPerm } = userDetails;
  const sortingArr = ['contacts', 'booking', 'label', 'distribution', "accounting", "settings", "analytics", "management", "promotion"]
  const m = sortFunc(allPerm.modules, sortingArr);
  console.log({ m });
  let modulesNodes = toPairs(m)
    .map((m, mi) => {
      return createNode({
        value: m[0],
        text: m[1],
        path: [mi],
        children: toPairs(allPerm.sub_menu).sort()
          .filter(s => s[0] && s[0].startsWith(m[0]))
          .map((s, si) =>
            createNode({
              value: s[0],
              text: s[1],
              path: [mi, si],
              children: toPairs(allPerm.tabs).sort()
                .filter(t => t[0] && t[0].startsWith(s[0]))
                .map((t, ti) =>
                  createNode({
                    value: t[0],
                    text: t[1],
                    path: [mi, si, ti]
                  })
                )
            })
          )
      });
    })
  const { modules, sub_menu, tabs } = (userPerm && userPerm.blocked) || {};

  modulesNodes.forEach(m => {

    if (
      modules &&
      modules.length &&
      modules.length > 0 &&
      modules.includes(m.value)
    ) {
      m.selected = true;
    }
    m.children &&
      m.children.length > 0 &&
      m.children.forEach(s => {
        if (
          sub_menu &&
          sub_menu.length &&
          sub_menu.length > 0 &&
          sub_menu.includes(s.value)
        ) {
          s.selected = true;
        }
        s.children &&
          s.children.length > 0 &&
          s.children.forEach(t => {
            if (
              tabs &&
              tabs.length &&
              tabs.length > 0 &&
              tabs.includes(t.value)
            ) {
              t.selected = true;
            }
          });
      });
  });

  return modulesNodes
};
const sortFunc = (o, sortingArr) => {
  return o && Object.keys(o).sort((a, b) => sortingArr.indexOf(a) - sortingArr.indexOf(b)).reduce((r, k) => (r[k] = o[k], r), {}) || {}
}


</script>

<style lang="scss">
.cmp-settings-user-hide-modules {
  padding: 10px;
  height: 100%;
  // height: 300px;
  display: flex;
  flex-direction: column;

  .dt-checkbox {
    // margin-top: 10px;
  }

  .select-tree {
    flex: 1;
    /* overflow-y: hidden; */
    overflow-y: auto;
    /* min-height: 190px; */
    max-height: calc(100vh - 240px);
    padding-bottom: 5px;
  }

  .save-button-container {
    flex: 0;
    display: flex;
    justify-content: flex-end;
  }

  // .checkbox-item {
  //   display: flex;
  //   .checkbox-label {
  //   }
  // }
}
</style>
